import axios from 'axios';
import rest from './rest';
import File from '@/models/file';


async function load() {
  const keys = (await rest.get('/files')).objects || [];
  const files = keys.filter(key => !key.endsWith('/'));
  File.create({data: files.map((key) => {
    return {
      key: key,
      link: `${rest.base}/downloads/${key}`
    };
  })});
}

async function url(key) {
  return (await rest.get(`/files/${key}`)).url;
}

async function read(key) {
  const file = File.query().where('key', key).first();
  return (await axios.get(await url(file.key))).data;
}

export default {
  load,
  url,
  read
};
